export default {"src":"/_next/static/media/see-more.c5dc5f89.svg","height":6,"width":8,"blurWidth":0,"blurHeight":0};